"use client";

import { createContext, useContext } from "react";
import type { SmartTableModel } from "./use-smart-table-model";

/**
 * Модель таблицы раздаётся частям через контекст, а не через пропсы: модель держит экземпляр
 * таблицы со всеми строками и ячейками, и в dev-сборке React обходит такие пропсы целиком
 * при каждой отрисовке каждого компонента, что останавливает страницу с широкой таблицей.
 */
export const SmartTableModelContext = createContext<SmartTableModel<unknown> | null>(null);

/** Приводит модель к значению контекста: в контексте тип данных строки не известен. */
export function toModelContextValue<TData>(model: SmartTableModel<TData>): SmartTableModel<unknown> {
  return model as unknown as SmartTableModel<unknown>;
}

export function useSmartTableModelContext<TData>(): SmartTableModel<TData> {
  const model = useContext(SmartTableModelContext);
  if (model === null) throw new Error("SmartTable parts must be rendered inside SmartTable");
  return model as unknown as SmartTableModel<TData>;
}
